export default{
    section:'بخش',
    indicationsTitle: 'عنوان',
    sectionStatus: 'وضعیت',
    indications:'indications',
    editIndications:'ویرایش Indications',
    addIndications:'indications جدید',
}